import React from 'react';
import AsyncSelect from 'react-select/async';

const SearchForm = ({ 
  mandateId, 
  setMandateId, 
  loading, 
  handleSearch, 
  resetForm, 
  allMandates, 
  recentMandates 
}) => {
  // Helper to map mandates to options
  const mapMandatesToOptions = (mandates) =>
    mandates.map(mandate => ({
      value: String(mandate.id),
      label: `${mandate.id} - ${mandate.job_title}`
    }));

  // Show only a few recent mandates initially
  const initialOptions = mapMandatesToOptions(recentMandates.slice(0, 10));

  // Async loadOptions for AsyncSelect
  const loadMandateOptions = (inputValue, callback) => {
    // If no input, show a few recent mandates
    if (!inputValue) {
      callback(initialOptions);
      return;
    }
    // Filter allMandates by inputValue (case-insensitive, match id or job_title)
    const filtered = allMandates.filter(mandate =>
      mandate.id.toString().includes(inputValue) ||
      (mandate.job_title && mandate.job_title.toLowerCase().includes(inputValue.toLowerCase()))
    );
    // Limit to 20 results for performance
    callback(mapMandatesToOptions(filtered.slice(0, 20)));
  };

  return (
    <div className="search-section" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '220px' }}>
      <form onSubmit={handleSearch} className="search-form" style={{ width: '100%', maxWidth: 500 }}>
        <div className="form-group" style={{ width: '100%' }}>
          <label htmlFor="mandate_id" style={{ fontSize: '1.2rem', textAlign: 'center', width: '100%' }}>
            📄 Select Mandate *
          </label>
          <AsyncSelect
            id="mandate_id"
            name="mandate_id"
            cacheOptions
            defaultOptions={initialOptions}
            loadOptions={loadMandateOptions}
            value={(() => {
              // Find the selected option in allMandates
              const found = allMandates.find(m => String(m.id) === mandateId);
              return found ? { value: String(found.id), label: `${found.id} - ${found.job_title}` } : null;
            })()}
            onChange={option => setMandateId(option ? option.value : '')}
            placeholder="Select a recent mandate..."
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                fontSize: '1.5rem',
                padding: '4px',
                borderRadius: '12px',
                border: '2px solid #e1e5e9',
                background: '#f8f9fa',
                margin: '24px 0'
              }),
              menu: (provided) => ({
                ...provided,
                fontSize: '1.1rem',
              }),
            }}
          />
        </div>
        <div className="form-actions" style={{ justifyContent: 'center', alignItems: 'center', gap: 16 }}>
          <button type="submit" disabled={loading} className="search-btn" style={{ fontSize: '1.2rem', minWidth: 180 }}>
            {loading ? '🔄 Searching...' : '🔍 Search Candidates'}
          </button>
          <button type="button" onClick={resetForm} className="reset-btn" style={{ fontSize: '1.2rem', minWidth: 120 }}>
            🗑️ Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchForm; 